import React from "react";
import { Icon } from "@iconify/react";

const routes = [
  { route: "dashboard", icon: <Icon icon="lucide:layout-dashboard" />, text: "Dashboard" },
  { route: "assigned", icon: <Icon icon="codicon:book" />, text: "Assigned" },
  { route: "explore", icon: <Icon icon="lucide:clipboard-list" />, text: "Explore" },
];

export default routes;
